import * as React from "react";

import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import { Card } from "@mui/material";

export default function AndroidGuide() {
  const androidGuideArray = [
    {
      step: "1",
      guide:
        "Open this app from Chrome browser and You'll see a pop up named add to homescreen.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "2",
      guide:
        "However If you can't see the popup. Goto settings select the Add to homescreen method.",
      buttonName: "Settings",
      url: "app-prefs://prefs:root",
      click: "",
      buttonIcon: SettingsApplicationsIcon,
    },
    {
      step: "3",
      guide:
        "Tap on the Add button and Wait few second for the Installation process.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "4",
      guide: "After the installation success, Go to homescreen.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "5",
      guide: "You will see the cartube installer in the home screen.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "6",
      guide: "Tap on the Cartube Installer Icon and open it.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "7",
      guide: "Enjoy!",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
  ];

  return (
    <div>
      <Box>
        <Typography sx={{ mt: -2, fontWeight: "bold" }}>
          You are on Android phone
        </Typography>
      </Box>
      {androidGuideArray.map((item) => (
        <Card
          key={item.step}
          sx={{
            p: 1.5,
            textAlign: "left",
            mt: 1,

            borderRadius: 0,
            "&:hover": {
              backgroundColor: "#f2d8d8",
            },
            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>Step {item.step}</Typography>

          <Typography variant="body2" sx={{ textAlign: "justify" }}>
            {item.guide}
          </Typography>
          {item.click !== "" ? (
            <Box sx={{ mt: 1, textAlign: "left" }}>
              <Button
                // fullWidth={true}

                size="medium"
                disableElevation
                variant="contained"
                endIcon={<item.buttonIcon />}
                onClick={() => item.click(item.url)}
                sx={{ textTransform: "none", width: "60%" }}
              >
                {item.buttonName}
              </Button>
            </Box>
          ) : null}
        </Card>
      ))}
    </div>
  );
}
